import type { OptimizerAuditV2Record } from '../../types/audit.types';

/** Matches optimizer fundingPools: max(0, MV − expected cash) per sleeve. */
export const resolveSubAccountInvestableCents = (
  marketValueCents: number,
  expectedCashCents: number,
): number => Math.max(0, marketValueCents - expectedCashCents);

export const resolvePortfolioInvestableCentsFromAudit = (
  audit: OptimizerAuditV2Record | undefined,
): number =>
  (audit?.subAccountResults ?? []).reduce(
    (sum, result) =>
      sum +
      resolveSubAccountInvestableCents(
        result.inputMarketValueCents ?? 0,
        result.inputCashCents ?? 0,
      ),
    0,
  );

export const resolvePortfolioInvestableCentsFromSubAccounts = (
  subAccounts: Array<{
    marketValueCents?: number | null;
    expectedCashCents?: number | null;
  }>,
): number =>
  subAccounts.reduce(
    (sum, subAccount) =>
      sum +
      resolveSubAccountInvestableCents(
        subAccount.marketValueCents ?? 0,
        subAccount.expectedCashCents ?? 0,
      ),
    0,
  );
